import React, { Fragment, useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";
import { Btn, H3, H4, P, Image } from "../../../../AbstractElements";
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import { Row, Col, Container, Card, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import TableBuilder, { RegisteredInputsBuilder, ApiRequestBuilder, ToastBuilder } from '../../../../GlobalComponents/Builders';
import { setInitialFormValues } from '../../../../GlobalComponents/Helpers';

document.title = 'View User';

const Role = () => {

    let { roleId } = useParams();

    const [roleData, setData] = useState([]);
    const [functionData, setFunctionData] = useState([]);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const getRoleData = () => {

        ApiRequestBuilder('rolesRoleIdGet', { roleId }).then(function(results) {
            setInitialFormValues(results.data, setValue)
            console.log('roleData',roleData)
            setData(results.data);
        });

        ApiRequestBuilder('functionsGet').then(function(results) {
            setInitialFormValues(results.data, setValue)
            setFunctionData(results.data.map(funct => { return { value: funct.function_id, label: funct.name} } ));
        });
    };

    useEffect(() => {
        getRoleData();
    }, []);

    return (
        <Fragment>
            <Row>
                <Col xl="6">
                    <Form onSubmit={handleSubmit()}>
                        <Card>
                            <CardHeader>
                                <h4>Edit Role</h4>
                            </CardHeader>
                            <CardBody>
                                <RegisteredInputsBuilder
                                    registrator={register}
                                    registratorErrors={errors}
                                    inputs={[
                                        {
                                            label: 'Name',
                                            size: 12,
                                            name: 'name'
                                        },
                                        {
                                            label: 'Description',
                                            size: 12,
                                            name: 'description'
                                        }
                                    ]}
                                />
                            </CardBody>
                            <CardFooter className="text-end">
                                <Btn attrBtn={{ color: "primary", type: "submit" }} >{'Update Role'}</Btn>
                            </CardFooter>
                        </Card>
                    </Form>
                </Col>
                <Col sm="6">
                    <Card>
                        <CardBody>
                            <TableBuilder
                                data={roleData.users ? roleData.users : []}
                                title='Assigned Users'
                                processing={false}
                                sortField={null}
                                columns = {[
                                    {
                                        name: 'Partner',
                                        selector: (row) => row.partner_name ? row.partner_name : 'Admin',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Name',
                                        selector: (row) => row.full_name,
                                        sortable: true,
                                        center: true,
                                    }
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="6">
                    <Card>
                        <CardHeader>
                            <H4>Add Permissions</H4>
                        </CardHeader>
                        <CardBody>
                            <Label className="col-form-label">Permissions</Label>
                            <Select
                                options={functionData} 
                                className="js-example-basic-single col-sm-12"
                                isMulti
                                onChange={() => {}} />
                        </CardBody>
                        <CardFooter>
                            <Btn color="primary">Update</Btn>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Role;